import httpClient from 'utils/httpClient.js';
import { withPortalScope } from 'utils/portalScope';

const route = '/sl-prices';

export const getList = (params) => {
  return httpClient.get(route, { params: withPortalScope(params) });
};

export const create = (params) => {
  return httpClient.post(route, withPortalScope(params));
};

export const createComboPrice = (params) => {
  return httpClient.post(route + `/combo`, withPortalScope(params));
};

export const update = (id, params) => {
  return httpClient.put(route + `/${id}`, withPortalScope(params));
};

export const read = (id, params) => {
  return httpClient.get(route + `/${id}`, { params: withPortalScope(params) });
};

export const deleteItem = (id, params = {}) => {
  return httpClient.delete(route + `/${id}`, { params: withPortalScope(params) });
};

export const stopPrice = (id, params = {}) => {
  return httpClient.put(route + `/${id}/change-status`, withPortalScope({ ...params, is_active: 0 }));
};

export const stopPrices = (priceIds) => {
  return httpClient.put(route + '/bulk-stop', withPortalScope({ price_ids: priceIds }));
};

export const getStoreOpts = (params = {}) => {
  return httpClient.get(`/store`, { params: withPortalScope(params) });
};

export const getListProduct = (params = {}) => {
  return httpClient.get(route + `/prices-list`, { params: withPortalScope(params) });
};

export const areaByOutputTypeOpts = (params = {}) => {
  return httpClient.get(route + `/list-area-by-output-type`, { params: withPortalScope(params) });
};

export const getBusinessOfAreaOpts = (params = {}) => {
  return httpClient.get(route + `/list-business-by-area`, { params: withPortalScope(params) });
};

export const getPriceMasterData = (params = {}) => {
  return httpClient.get(route + `/master-data`, { params: withPortalScope(params) });
};

export const readDetialOuputType = (id, params = {}) => {
  return httpClient.get(`/output-type/${id}`, { params: withPortalScope(params) });
};
// Lấy chi tiết giá sản phẩm hoặc của nguyên liệu
export const detailProduct = (id, params = {}) => {
  return httpClient.get(route + `/product/${id}`, { params: withPortalScope(params) });
};
// Lấy chi tiết các thuộc tính của model
export const detailModelAttribute = (params = {}) => {
  return httpClient.get(route + `/model/attribute`, { params: withPortalScope(params) });
};
// Lấy chi tiết giá sản phẩm
export const detailPrices = (id, params = {}) => {
  return httpClient.get(route + `/${id}`, { params: withPortalScope(params) });
};

// Lấy chi tiết giá theo sản phẩm
export const detailPriceProduct = (id, params = {}) => {
  return httpClient.get(route + `/option/product/${id}`, { params: withPortalScope(params) });
};
// Lấy chi tiết giá sản phẩm theo tùy chọn
export const detailPricesByOption = (id, params = {}) => {
  return httpClient.get(route + `/option/${id}`, { params: withPortalScope(params) });
};
// Duyệt giá cho sản phẩm
export const reviewPrices = (id, params = {}) => {
  return httpClient.put(route + `/${id}/review`, withPortalScope(params));
};
// danh sách lịch sử giá sản phẩm
export const getListPriceProductHistory = (params = {}) => {
  return httpClient.get(route + `/prices-list/history`, { params: withPortalScope(params) });
};
// Lưu danh sách áp dụng điều chỉnh giá
export const changePriceMultiProduct = (params = {}) => {
  return httpClient.post(route + `/prices-list`, withPortalScope(params));
};

export const downloadTemplate = (_data) => {
  const header = {
    responseType: `blob`,
  };
  return httpClient.get(`${route}/download-excel`, header);
};

export const importExcel = (file) => {
  let formData = new FormData();
  formData.append(`priceimport`, file);
  return httpClient.post(`${route}/import-excel`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
